<template>
  <div class="pb-16">
    <CategoriesSection v-if="smAndDown" />
    <SlideShowSection />
    <CategoriesSection v-if="!smAndDown" />
    <ProductsByCategoriesSection />
    <ProductModalWidget />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import ProductsByCategoriesSection from "../components/sections/ProductsByCategoriesSection.vue";
import ProductModalWidget from "../components/widgets/ProductModalWidget.vue";
import CategoriesSection from "../components/sections/CategoriesSection.vue";

export default {
  components: {
    SlideShowSection,
    ProductsByCategoriesSection,
    ProductModalWidget,
    CategoriesSection,
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
